import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReportAPI } from "../api/report";
import Loader from "../componets/Loader";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import {
  Box,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PrintReport from "../assets/SVGs/Report/PrintReport";
import dayjs from "dayjs";
import { formatCurrency } from "../componets/helper";

const MemberIndividualReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const closedBusinessData = await ReportAPI.getMemberIndividualReport(
        localStorage?.getItem("memberId"),
      );
      setData(closedBusinessData?.data);
    } catch (error) {
      const status = error.response?.status;
      if (status === 401) {
        navigate("/login");
      } else {
        console.error("Error fetching closed business report:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />

        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">{`${data?.full_name} Individual Report`}</h1>

          <IconButton
            sx={{
              border: "1px solid #AEBBCB",
              "@media print": {
                display: "none", // Hides the button during print
              },
            }}
            onClick={handlePrint}
            className="no-print"
          >
            <PrintReport className="no-print" />
          </IconButton>
        </div>
      </header>

      <Stack
        sx={{
          width: "100%",
          "& .MuiTable-root": {
            borderRadius: "8px",
          },
        }}
        className="customTable report-table"
      >
        <TableContainer component={Paper} className="customTable">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Membership Expiration Date</TableCell>
                <TableCell>Weekly Meets Attended</TableCell>
                <TableCell>Meet-Ups Attended</TableCell>
                <TableCell>Referrals Given</TableCell>
                <TableCell>Referrals Received</TableCell>
                <TableCell>Visitors Brought</TableCell>
                <TableCell>Closed Business Received </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data ? (
                <TableRow>
                  <TableCell>
                    {data.current_membership_status ? "Active" : "Inactive"}
                  </TableCell>
                  <TableCell>
                    {" "}
                    {dayjs(data.membership_expiration_date).format(
                      "MM/DD/YYYY",
                    )}
                  </TableCell>
                  <TableCell>{data.weekly_meetings_attended}</TableCell>
                  <TableCell>{data.meetups_attended}</TableCell>
                  <TableCell>{data.referrals_given}</TableCell>
                  <TableCell>{data.referrals_received}</TableCell>
                  <TableCell>{data.visitors_brought}</TableCell>
                  <TableCell>
                    {formatCurrency(data.closed_business_received)}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Box display="flex" justifyContent="center">
                      No Data Found
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </div>
  );
};

export default MemberIndividualReport;
